/* REACT PACKAGE IMPORTS */
import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

/* MUI PACKAGE IMPORTS */
import { ThemeProvider } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";

/* INTERNAL IMPORTS */
import { openModal } from "../../Features/Errors/Slices/errorSlice";
import ViewQuestion from "../Questions/ViewQuestion";
import { tagQuestion } from "../../Features/Sessions/Slices/sessionsSlice";
import {
  postQuestionFlag,
  deleteQuestionFlag,
} from "../../Features/Sessions/Actions/SessionsActions";
import { theme } from "../../styles/StyledComponents";
import "../../styles/Assessment.css";

export default function SessionAssessment({ sections, questions }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const sessionId = parseInt(id);

  const { taggedQuestions } = useSelector((store) => store.sessions);

  const handleTagQuestion = (question) => {
    const qid = question.questions[0].qid;
    dispatch(tagQuestion({ qid }));

    if (areQuestionsFlagged(qid)) {
      dispatch(deleteQuestionFlag({ esId: sessionId, qid }));
    } else {
      dispatch(postQuestionFlag({ esId: sessionId, qid }));
    }
  };

  const areQuestionsFlagged = (qid) => {
    if (!qid) return false;
    return taggedQuestions.includes(qid);
  };

  if (questions.length === 0) return null;

  const questionElements = questions.map((section) => {
    let questionNumber = -1;

    const sectionDetails = sections.map((formattedSection, index) => {
      if (section.sectionid === formattedSection.sectionID) {
        return (
          <h1 className="fw-bold mt-4 px-4 text-2xl">
            {formattedSection.title}
          </h1>
        );
      }
    });

    const questions = section?.questions?.map((question, i) => {
      questionNumber += 1;
      return (
        <div key={i}>
          <ViewQuestion
            position={questionNumber}
            questions={question?.questions || []}
            questionHeader={question}
            sessionId={sessionId}
          />
          <div className="d-flex mx-4 mb-4 justify-content-end align-content-center">
            <ThemeProvider theme={theme}>
              <IconButton
                aria-label="flag"
                color={
                  areQuestionsFlagged(question?.questions[0].qid)
                    ? "flag"
                    : "primary"
                }
                size="medium"
                onClick={() => handleTagQuestion(question)}
              >
                {areQuestionsFlagged(question?.questions[0].qid) ? (
                  <FlagIcon />
                ) : (
                  <FlagOutlinedIcon />
                )}
              </IconButton>
            </ThemeProvider>
          </div>
          <hr />
        </div>
      );
    });

    return (
      <>
        <div className="position-relative ">{sectionDetails}</div>
        <Container className="position-relative p-4">{questions}</Container>
      </>
    );
  });

  return questionElements;
}
